/**
 * NOBILE WOOD — Scroll Animations (Apple-minimal)
 * Subtle fade-up reveals + thin scroll progress bar
 */
(function(){
  'use strict';
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Inject minimal CSS */
  var s = document.createElement('style');
  s.textContent = [
    '[data-nw-r]{opacity:0;transform:translateY(20px);',
    'transition:opacity .6s cubic-bezier(.25,.1,.25,1),transform .6s cubic-bezier(.25,.1,.25,1);',
    'transition-delay:var(--nw-d,0ms);will-change:opacity,transform}',
    '[data-nw-r].nw-v{opacity:1!important;transform:none!important}',
    '#nw-sp{position:fixed;top:0;left:0;height:2px;width:100%;z-index:99999;',
    'background:linear-gradient(90deg,#8B7355,#C4A97D);',
    'transform-origin:left;transform:scaleX(0);pointer-events:none}'
  ].join('');
  document.head.appendChild(s);

  function init(){
    /* Tag elements for reveal */
    var sels = '.nw-prod,.nw-del-card,.nw-prodcard,[data-nw-reveal]';
    document.querySelectorAll(sels).forEach(function(el){
      if(!el.hasAttribute('data-nw-r')) el.setAttribute('data-nw-r','');
    });

    /* Add stagger to siblings */
    var groups = ['.nw-prod','.nw-del-card','.nw-prodcard'];
    groups.forEach(function(sel){
      var parents = new Map();
      document.querySelectorAll(sel).forEach(function(el){
        var p = el.parentElement;
        if(!parents.has(p)) parents.set(p,[]);
        parents.get(p).push(el);
      });
      parents.forEach(function(children){
        children.forEach(function(el,i){
          el.style.setProperty('--nw-d', Math.min(i*80,400)+'ms');
        });
      });
    });

    /* Observe */
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('nw-v');
          obs.unobserve(e.target);
        }
      });
    },{threshold:.1,rootMargin:'0px 0px -40px 0px'});

    document.querySelectorAll('[data-nw-r]').forEach(function(el){
      var r = el.getBoundingClientRect();
      if(r.top < window.innerHeight + 50){
        el.classList.add('nw-v');
      } else {
        obs.observe(el);
      }
    });

    /* Scroll progress bar */
    var bar = document.createElement('div');
    bar.id = 'nw-sp';
    document.body.appendChild(bar);
    var spH = document.documentElement.scrollHeight - window.innerHeight;
    var spTicking = false;
    function spUpdate(){
      bar.style.transform = 'scaleX('+(spH>0?window.scrollY/spH:0)+')';
      spTicking = false;
    }
    window.addEventListener('scroll',function(){
      if(!spTicking){ spTicking = true; requestAnimationFrame(spUpdate); }
    },{passive:true});
    window.addEventListener('resize',function(){
      spH = document.documentElement.scrollHeight - window.innerHeight;
    },{passive:true});
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',function(){setTimeout(init,200)});
})();
